import React from 'react';
import { ClockIcon, TrendingUpIcon, DollarSignIcon, CheckCircleIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: ClockIcon,
    stat: '70%',
    label: 'Time Saved',
    description: 'Less time coordinating diets, more time for patient care',
    color: 'text-blue-600'
  }, {
    icon: TrendingUpIcon,
    stat: '3x',
    label: 'Faster Results',
    description: 'Patients reach health metrics quicker with consistent adherence',
    color: 'text-green-600'
  }, {
    icon: DollarSignIcon,
    stat: '40%',
    label: 'Cost Reduction',
    description: 'Lower total cost of care through better outcomes',
    color: 'text-orange-600'
  }, {
    icon: CheckCircleIcon,
    stat: '90%',
    label: 'Adherence Rate',
    description: 'Automated tracking ensures patients stay on track',
    color: 'text-emerald-600'
  }];
  return <section className="py-20 bg-gradient-to-b from-green-50 to-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-4">
            Real Impact for Care Teams
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-5">
            Lola helps RDNs and care teams achieve better outcomes with less
            effort
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-6">
          {benefits.map((benefit, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1" data-id="element-7">
              <benefit.icon className={`w-12 h-12 ${benefit.color} mb-4`} data-id="element-8" />
              <div className={`text-5xl font-bold ${benefit.color} mb-2`} data-id="element-9">
                {benefit.stat}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-10">
                {benefit.label}
              </h3>
              <p className="text-gray-600" data-id="element-11">{benefit.description}</p>
            </div>)}
        </div>

        <div className="mt-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-3xl p-10 text-white text-center shadow-2xl" data-id="element-12">
          <h3 className="text-3xl font-bold mb-4" data-id="element-13">
            Stop Spending Hours on Diet Coordination
          </h3>
          <p className="text-xl mb-6 text-green-50 max-w-3xl mx-auto" data-id="element-14">
            RDNs spend countless hours tracking patient diets manually. Lola
            automates the entire process—from personalized recommendations to
            real-time adherence monitoring—so you can focus on what matters
            most: patient care.
          </p>
          <button className="bg-white text-green-600 px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all" data-id="element-15">
            Schedule a Demo
          </button>
        </div>
      </div>
    </section>;
}